import { Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { VerificationAgencyService } from "../../../Component/Api/VerificationAgency/VerificationAgencyService";
import { LockedScorecardsPage } from "../BEEScorecards/LockedScorecards";

export const VALockedScorecardHomepage = () => {

    const [companyName, setCompanyName] = useState<string>('');

    const fetchData = async () => {
        try {
            let response = await VerificationAgencyService.GetVaDetails();
            setCompanyName(response.data.vaName);
        } catch (error) { }
    }

    useEffect(() => {
        fetchData();
    }, []);

    return (
        <>
            <Typography variant='h4' fontWeight='bold' sx={{ paddingBottom: "15px" }}>
                {companyName}
            </Typography>
            <LockedScorecardsPage />
        </>
    )
}